import React from "react";

export default function Annexure6(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Schematic Flow Chart of Reporting & Response Process (Annexure-6)
      </h1>

      <div className="space-y-5">
        <div className="flex justify-center w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 800"
            className="w-full max-w-4xl"
          >
            {/* Styles */}
            <defs>
              <style>
                {`
              .box {
                fill: #fff;
                stroke: #d08770;
                stroke-width: 2;
                rx: 10;
                ry: 10;
              }
              .arrow {
                stroke: #88c0d0;
                stroke-width: 2;
                fill: none;
                marker-end: url(#arrowhead);
              }
              text {
                font-family: Arial, sans-serif;
                font-size: 12px;
                fill: #2e3440;
              }
              .title {
                font-weight: bold;
                text-anchor: middle;
              }
            `}
              </style>
              <marker
                id="arrowhead"
                markerWidth="10"
                markerHeight="7"
                refX="9"
                refY="3.5"
                orient="auto"
              >
                <polygon points="0 0, 10 3.5, 0 7" fill="#88c0d0" />
              </marker>
            </defs>
            {/* Top box: Initial Concerns */}
            <rect className="box" x="400" y="20" width="200" height="80" />
            <text x="500" y="40" className="title">
              CSP concerns/incident (ref.
            </text>
            <text x="500" y="60" className="title">
              Para 6.1, 6.2,6.4) are noticed
            </text>
            <text x="500" y="80" className="title">
              at SS workplaces/ grounds
            </text>
            {/* Report box */}
            <rect className="box" x="400" y="130" width="200" height="90" />
            <text x="500" y="150" textAnchor="middle">
              Immediate report to be made
            </text>
            <text x="500" y="165" textAnchor="middle">
              through phone call to
            </text>
            <text x="500" y="180" textAnchor="middle">
              CPO/KYS or CEO/SS followed
            </text>
            <text x="500" y="195" textAnchor="middle">
              by written incident report
            </text>
            <text x="500" y="210" textAnchor="middle">
              (ref. Para 6.1 & 6.3)
            </text>
            {/* Actions by CPO box */}
            <rect className="box" x="350" y="250" width="310" height="140" />
            <text x="500" y="270" className="title">
              Actions by CPO:
            </text>
            <text x="360" y="290" textAnchor="start">
              1. Immediately give first information to CEO & stamp;
            </text>
            <text x="360" y="305" textAnchor="start">
              child's parents/ carers in person or through phone
            </text>
            <text x="360" y="320" textAnchor="start">
                call
            </text>
            <text x="360" y="335" textAnchor="start">
              2. Take steps to ensure safety of the child
            </text>
            <text x="360" y="350" textAnchor="start">
              3. Collect/ compile max. possible information regarding
            </text>
            <text x="360" y="365" textAnchor="start">
              the incident
            </text>
            <text x="360" y="380" textAnchor="start">
              4. Convene and lead CSPG in holding Internal Inquiry
            </text>
            {/* Actions by CEO/SS left side */}
            <rect className="box" x="5" y="175" width="200" height="165" />
            <text x="105" y="195" className="title">
              Actions by CEO/SS:
            </text>
            <text x="65" y="210" textAnchor="start">
              (ref. Para 7.3)
            </text>
            <text x="15" y="225" textAnchor="start">
              1. If allegations involve visitors/ 
            </text>
            <text x="15" y="240" textAnchor="start">
              outsiders/ unknown persons, CEO 
            </text>
            <text x="15" y="255" textAnchor="start">
              to inform CWC of district. Also, 
            </text>
            <text x="15" y="270" textAnchor="start">
              seek advice of CWC for further 
            </text>
            <text x="15" y="285" textAnchor="start">
              action to be taken by SS.
            </text>
            <text x="15" y="300" textAnchor="start">
              2. If allegations involve staff/ 
            </text>
            <text x="15" y="315" textAnchor="start">
              associates of SS/KYS initiate 
            </text>
            <text x="15" y="330" textAnchor="start">
              internal action as per policy.
            </text>
            {/* Inform CEO box */}
            <rect className="box" x="245" y="270" width="75" height="55" />
            <text x="283" y="290" className="title">
              Immediately
            </text>
            <text x="283" y="305" className="title">
              Inform
            </text>
            <text x="283" y="320" className="title">
              CEO/SS
            </text>
            {/* Inform Parents box */}
            <rect className="box" x="700" y="295" width="120" height="55" />
            <text x="760" y="313" className="title">
              Immediately inform
            </text>
            <text x="760" y="328" className="title">
              child's parents/
            </text>
            <text x="760" y="343" className="title">
              carers
            </text>
            {/* Instruction to Stop box */}
            <rect className="box" x="5" y="370" width="220" height="70" />
            <text x="15" y="385" textAnchor="start" className="font-semibold">
              Issue instruction to the concerned
            </text>
            <text x="15" y="400" textAnchor="start" className="font-semibold">
              to immediately stop attending
            </text>
            <text x="15" y="415" textAnchor="start" className="font-semibold">
              their office/ workplace pending
            </text>
            <text x="15" y="430" textAnchor="start" className="font-semibold">
              CSPG Inquiry.
            </text>
            {/* Internal Inquiry box */}
            <rect className="box" x="415" y="420" width="170" height="70" />
            <text x="500" y="438" className="title">
              CPO to submit Internal
            </text>
            <text x="500" y="453" className="title">
              Inquiry Report (findings &
            </text>
            <text x="500" y="468" className="title">
              recommendations) to
            </text>
            <text x="500" y="483" className="title">
              CEO/SS within 15 days
            </text>
            {/* Unsubstantiated box */}
            <rect className="box" x="225" y="450" width="175" height="55" />
            <text x="310" y="468" textAnchor="middle">
              Concerns/ allegations
            </text>
            <text x="310" y="483" textAnchor="middle">
              found unsubstantiated as
            </text>
            <text x="310" y="498" textAnchor="middle">
              per CSPG Inquiry
            </text>
            {/* Poor practice box */}
            <rect className="box" x="413" y="520" width="175" height="55" />
            <text x="500" y="538" textAnchor="middle">
              Concerns/ allegations found
            </text>
            <text x="500" y="553" textAnchor="middle">
              to be a case of poor practice
            </text>
            <text x="500" y="568" textAnchor="middle">
              as per CSPG Inquiry
            </text>
            {/* Child abuse box */}
            <rect className="box" x="700" y="430" width="175" height="60" />
            <text x="790" y="450" textAnchor="middle">
              Concerns/ allegations found
            </text>
            <text x="790" y="465" textAnchor="middle">
              to be case of child abuse as
            </text>
            <text x="790" y="480" textAnchor="middle">
              per CSPG Inquiry
            </text>
            {/* Unsubstantiated actions box */}
            <rect className="box" x="5" y="538" width="200" height="85" />
            <text x="105" y="555" className="title">
              If concerns unsubstantiated
            </text>
            <text x="105" y="570" className="title">
              CEO/SS shall revoke/ withdraw
            </text>
            <text x="105" y="585" className="title">
              earlier instructions and ask
            </text>
            <text x="105" y="600" className="title">
              concerned individual to resume
            </text>
            <text x="105" y="615" className="title">
              their duties
            </text>
            {/* Poor practice actions box */}
            <rect className="box" x="413" y="600" width="205" height="110" />
            <text x="500" y="615" className="title">
              Actions by CEO/SS:
            </text>
            <text x="423" y="630" textAnchor="start">
              1. Take appropriate disciplinary
            </text>
            <text x="423" y="645" textAnchor="start">
              action against the concerned staff/
            </text>
            <text x="423" y="660" textAnchor="start">
              associate
            </text>
            <text x="423" y="675" textAnchor="start">
              2. Institute steps for corrective and
            </text>
            <text x="423" y="690" textAnchor="start">
              precautionary measures to prevent
            </text>
            <text x="423" y="705" textAnchor="start">
              recurrence.
            </text>
            {/* Child abuse actions box */}
            <rect className="box" x="695" y="565" width="175" height="90" />
            <text x="785" y="585" className="title">
              Actions by CEO/SS:
            </text>
            <text x="710" y="600" textAnchor="start">
              1. Refer the case to district
            </text>
            <text x="710" y="615" textAnchor="start">
              CWC
            </text>
            <text x="710" y="630" textAnchor="start">
              2. Seek advice of CWC on
            </text>
            <text x="710" y="645" textAnchor="start">
              further course of action
            </text>
            {/* Arrows */}
            <path className="arrow" d="M500,100 L500,130" />
            <path className="arrow" d="M500,220 L500,250" />
            <path className="arrow" d="M350,300 L320,300" />
            <path className="arrow" d="M245,300 L205,300" />
            <path className="arrow" d="M660,325 L700,325" />
            <path className="arrow" d="M105,340 L105,368" />
            <path className="arrow" d="M500,390 L500,420" />
            <path className="arrow" d="M390,390 L330,450" />
            <path className="arrow" d="M500,575 L500,600" />
            <path className="arrow" d="M650,390 L720,430" />
            <path className="arrow" d="M225,485 L110,495" />
            <path className="arrow" d="M500,490 L500,520" />
            <path className="arrow" d="M780,490 L780,565" />
            <path className="arrow" d="M105,440 L105,536" />
          </svg>
        </div>

        

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Abbreviations
          </h2>
          <ul className="space-y-1 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">1.</span>
              <span className="text-gray-700">
                CSP: Child Safeguarding & Protection
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">2.</span>
              <span className="text-gray-700">
                CSPG: Child Safeguarding & Protection Group
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">3.</span>
              <span className="text-gray-700">
                CWC: Child Welfare Committee
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">4.</span>
              <span className="text-gray-700">
                CPO: Child Protection Officer
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">5.</span>
              <span className="text-gray-700">
                CEO: Chief Executive Officer
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">6.</span>
              <span className="text-gray-700">KVS: Krida Vikas Sanstha</span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">7.</span>
              <span className="text-gray-700">SS: Slum Soccer</span>
            </li>
          </ul>
        </div>

        <div className="mt-2">
          <div className="rounded-xl p-3 text-white bg-gray-500 italic ">
            Note: The above flow chart is a thematic representation of reporting
            and response process of SS/KVS’s CSP Policy. For details, please
            refer Para 6 &7 of the Policy.
          </div>
        </div>
      </div>
    </div>
  );
}
